import { h, Component } from 'preact';

import Dialog from 'q-mdc/quikr/core/customDialog';
import Button from 'q-mdc/elements/material-button';

import AddToHomeScreen from '../icons/headerIcons/addToHomeScreen';
import ArrowATH from '../icons/headerIcons/arrowATH';
import { getEventTrackGA } from '../../helpers/ga';

export default class extends Component {

	componentDidMount() {
		window.addEventListener('beforeinstallprompt', (e) => {
			e.preventDefault();
			this.prompt = e;
		});

		setTimeout(() => {
			this.setState({
				addAnimation: true
			});
		}, 1500);
	}

	handleAddToHomeScreen = (e) => {
		const gaEventObject = {
			category: 'quikr_pwa',
			action: 'quikr_pwa_addtohomescreen',
			label: 'quikr_pwa_addtohomescreen_click'
		};
		getEventTrackGA(gaEventObject);
		if (this.prompt) {
			this.prompt.prompt();
			this.prompt.userChoice.then((choiceResult) => {
				if (choiceResult.outcome === 'accepted') {
					getEventTrackGA({
						category: 'quikr_pwa',
						action: 'quikr_pwa_addtohomescreen',
						label: 'quikr_pwa_addtohomescreen_success'
					});
				} else {
					getEventTrackGA({
						category: 'quikr_pwa',
						action: 'quikr_pwa_addtohomescreen',
						label: 'quikr_pwa_addtohomescreen_failure'
					});
				}
			});
		} else {
			this.setState({
				showDialog: true
			});
		}
	}

	handleDialogClose = () => {
		this.setState({
			showDialog: false
		});
	}
  

	render() {
		const { showDialog, addAnimation } = this.state;

		return (<div>
			<a onClick={this.handleAddToHomeScreen} class={`mdc-toolbar__icon add-to__icon ${addAnimation && 'icon-highlight'}`}><AddToHomeScreen class="icon" /></a>
			<Dialog
				className="trasparent-dialog"
				full
				showDialog={showDialog}
				body={(<div class="dialog-content">
					<ArrowATH class="up-arrow" />
					<h3>Add Quikr Lite to Homescreen</h3>
					<p>Select <span>Add to homescreen</span> from browser more menu <em>&hellip;</em> to pin the Quikr lite web app</p>
					<Button compact dense onClick={this.handleDialogClose}>GOT IT</Button>
				</div>)}
			/>
		</div>);
	}
}


// WEBPACK FOOTER //
// ../q-components/components/addToHomescreen/index.js